import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("afrimeet_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      const code = err?.response?.data?.detail?.code;
      // Skip during OTP flow — the OTP page itself handles 400/429 errors.
      if (!path.startsWith("/auth") && path !== "/") {
        localStorage.removeItem("afrimeet_token");
        localStorage.removeItem("afrimeet_user");
        if (code === "session_invalidated") {
          // Surface a friendly message on the login page
          sessionStorage.setItem(
            "afrimeet_session_invalidated",
            "Votre compte a été connecté sur un autre appareil. Veuillez vous reconnecter."
          );
        }
        window.location.href = "/auth/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
